<template>
  <div>
    <h2 class="mobile-page-title">Add/View Comments</h2>
    <div class="gpr-info comments" v-for="comment in project.comments" :key="comment.ats">
      <div class="top-row">
        <h6>{{comment.user_name}}</h6>
        <small>
          {{comment.created_at | formatDate}}
          <md-icon
            v-if="comment.user_id == userid"
            class="delete-comment"
            v-on:click.native="deleteComment(comment.id)"
          >close</md-icon>
        </small>
      </div>
      <p>{{comment.content}}</p>
    </div>
    <div class="new-message">
      <md-field>
        <label>Add a Comment</label>
        <md-textarea v-model="newComment.content" md-autogrow></md-textarea>
      </md-field>
      <md-button class="md-sm md-success" @click="addNewComment">Post Comment</md-button>
    </div>
  </div>
</template>
<script>
  import api from "@/api";
  import moment from 'moment';
  export default {
    props: ['project'],
    data() {
      return {
        comments: [
          {
            id: 1,
            userName: 'Tony Blowers',
            createdAt: '10 Mar 2020',
            message: "Hello, here's a message. we need to decide how we want to have notifications. we should notify you."
          },
        ],
        newComment: {
          content: '',
          project_id: '',
          user_id: ''
        },
        userid: ''
      }
    },
    mounted(){
      console.log(this.project.comments);
      this.userid = this.$store.state.user.id;
    },
    methods: {
      addNewComment() {
        this.newComment.user_id = this.userid;
        this.newComment.project_id = this.project.project.id;
        api.addComment(this.newComment).then((response) => {
          console.log(this.project)
          this.project.comments.push(response.data)
          this.newComment.content = '';

        })
      },
      deleteComment(comment_id){
        api.deleteComment(comment_id).then((response) => {
          this.$emit("deleteComment", comment_id)
        })
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('MM/DD/YYYY')
        }
      }
    }
  }
</script>
<style lang="scss">
  .delete-comment {
    cursor: pointer;
  }
</style>
